import React, { useContext, createContext, useState } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Redirect,
  Link,
  useHistory,
  useLocation,
  withRouter,
  RouteComponentProps,
} from "react-router-dom";
import "./App.css";
import Login from "./modules/user/login/Login1";
import Forgot from "./modules/user/forgot/Forgot";
import ForgotSuccess from "./modules/user/forgot/ForgotSuccess";
import Home from "./modules/home/Home";
import Help from "./modules/help/Help";
import Learning from "./modules/learning/Learning";
import PublicRoutes from "./routes/PublicRoutes";
import Policies from "./modules/policies/Policies";
import PolicyDetails from "./modules/policies/PolicyDetails";
import PrivateRoutes from "./routes/PrivateRoutes";
import Profile from "./modules/user/profile/Profile";
import CodeViolationsDetails from "./modules/learning/sections/CodeViolationsDetails";
import VerifyOtp from "./modules/user/forgot/verifyOtp";
import SetPassword from "./modules/user/forgot/SetPassword";
import LearningModulesDetails from "./modules/learning/admin/LearningModulesDetails";
import LearningModulesEditDetails from "./modules/learning/admin/LearningModulesEditDetails";
import EthicsCounsellorDetails from "./modules/learning/admin/EthicsCounsellorDetails";
import EthicsCounsellorEditDetails from "./modules/learning/admin/EthicsCounsellorEditDetails";
import DocumentModulesDetails from "./modules/learning/admin/DocumentModulesDetails";
import DocumentModulesEditDetails from "./modules/learning/admin/DocumentModulesEditDetails";
import VideoModulesDetails from "./modules/learning/admin/VideoModulesDetails";
import VideoModulesEditDetails from "./modules/learning/admin/VideoModulesEditDetails";
import HelpDocumentModulesDetails from "./modules/help/admin/HelpDocumentModulesDetails";
import HelpDocumentModulesEditDetails from "./modules/help/admin/HelpDocumentModulesEditDetails";
import LegalDisclaimer from "./modules/copyright/LegalDisclaimer";
import PrivacyPolicy from "./modules/copyright/PrivacyPolicy";
import Sitemap from "./modules/copyright/Sitemap";
import Error from "./modules/user/login/Error";
import ChangePassowrd from "./modules/user/change/ChangePassword.jsx";
import Middleware from "./Middleware";
import InvestigatorsModuleDetails from "./modules/learning/admin/InvestigatorsModuleDetails";
import InvestigatorsModuleEdit from "./modules/learning/admin/InvestigatorsModuleEdit";
import InvestigatorsModuleEditDetails from "./modules/learning/admin/InvestigatorsModuleEditDetails";
import UserGroup from "./modules/role/UserGroup";
import { Row } from "react-bootstrap";
import RegisteredUser from "./modules/user/login/RegisteredUser";
import NewUserRegister from "./modules/user/login/NewUserRegister";
import RegisterSuccess from "./modules/user/login/RegisterSuccess";
import UserRegister from "./modules/user/login/UserRegister";
import ManageComapny from "./modules/mcompany/ManageCompany";
import LearningNew from "./modules/learning/LearningNew";
import LearningByCategory from "./modules/learning/LearningByCategory";
import DeclarationsNew from "./modules/help/sections/DeclarationsNew";
import PolicyList from "./modules/policies/PolicyList";
import Event from './modules/event/Event';
//import Login1 from "./modules/user/login/Login1";

// const fakeAuth = {
//   isAuthenticated: false,
//   signin(cb) {
//     fakeAuth.isAuthenticated = true;
//     setTimeout(cb, 100); // fake async
//   },
//   signout(cb) {
//     fakeAuth.isAuthenticated = false;
//     setTimeout(cb, 100);
//   },
// };

// const authContext = createContext();

// function ProvideAuth({ children }) {
//   const auth = useProvideAuth();
//   return <authContext.Provider value={auth}>{children}</authContext.Provider>;
// }

// function useAuth() {
//   return useContext(authContext);
// }

// function useProvideAuth() {
//   const [user, setUser] = useState(null);

//   const signin = (cb) => {
//     return fakeAuth.signin(() => {
//       setUser("user");
//       cb();
//     });
//   };

//   const signout = (cb) => {
//     return fakeAuth.signout(() => {
//       setUser(null);
//       cb();
//     });
//   };

//   return {
//     user,
//     signin,
//     signout,
//   };
// }

// function AuthButton() {
//   let history: any = useHistory();
//   let auth: any = useAuth();

//   return auth.user ? (
//     <p>
//       Welcome!{" "}
//       <button
//         onClick={() => {
//           auth.signout(() => history.push("/"));
//         }}
//       >
//         Sign out
//       </button>
//     </p>
//   ) : (
//     <p>You are not logged in.</p>
//   );
// }
function Routes(props: RouteComponentProps) {
  return (
    <>
      <Switch>
        <PrivateRoutes path='/home'>
          <Home />
        </PrivateRoutes>
        <PrivateRoutes path='/policies'>
          <PolicyList />
        </PrivateRoutes>
        {/* <PrivateRoutes path="/policies-new">
          <PolicyList />
        </PrivateRoutes> */}
        <PrivateRoutes path='/policy-details/:id'>
          <PolicyDetails />
        </PrivateRoutes>
        <PrivateRoutes path='/help'>
          <Help />
        </PrivateRoutes>
        <PrivateRoutes path='/disclosures'>
          <DeclarationsNew />
        </PrivateRoutes>
        <PrivateRoutes path='/learning/details/:categoryId'>
          <LearningModulesDetails />
        </PrivateRoutes>
        <PrivateRoutes path='/learning/:categoryId'>
          <LearningByCategory />
        </PrivateRoutes>
        <PrivateRoutes path='/learning'>
          <Learning />
        </PrivateRoutes>
        <PrivateRoutes path='/learning-new'>
          <LearningNew />
        </PrivateRoutes>
        <PrivateRoutes path='/code-violations-details'>
          <CodeViolationsDetails />
        </PrivateRoutes>
        <PrivateRoutes path='/profile'>
          <Profile />
        </PrivateRoutes>
        <PrivateRoutes path='/learningmodulesDetails'>
          <LearningModulesDetails />
        </PrivateRoutes>
        <PrivateRoutes path='/learningmodulesEditDetails'>
          <LearningModulesEditDetails />
        </PrivateRoutes>
        <PrivateRoutes path='/ethicscounsellorDetails'>
          <EthicsCounsellorDetails />
        </PrivateRoutes>
        <PrivateRoutes path='/ethicscounsellorEditDetails'>
          <EthicsCounsellorEditDetails />
        </PrivateRoutes>
        <PrivateRoutes path='/documentmodulesDetails'>
          <DocumentModulesDetails />
        </PrivateRoutes>
        <PrivateRoutes path='/document/details/:categoryId'>
          <DocumentModulesDetails />
        </PrivateRoutes>
        <PrivateRoutes path='/documentmodulesEditDetails'>
          <DocumentModulesEditDetails />
        </PrivateRoutes>
        <PrivateRoutes path='/InvestigatorsModuleDetails'>
          <InvestigatorsModuleDetails />
        </PrivateRoutes>
        <PrivateRoutes path='/InvestigatorsModuleEdit'>
          <InvestigatorsModuleEdit />
        </PrivateRoutes>
        <PrivateRoutes path='/InvestigatorsModuleEditDetails'>
          <InvestigatorsModuleEditDetails />
        </PrivateRoutes>
        <PrivateRoutes path='/helpdocumentmodulesDetails'>
          <HelpDocumentModulesDetails />
        </PrivateRoutes>
        <PrivateRoutes path='/helpdocumentmodulesEditDetails'>
          <HelpDocumentModulesEditDetails />
        </PrivateRoutes>

        <PrivateRoutes path='/videomodulesDetails'>
          <VideoModulesDetails />
        </PrivateRoutes>
        <PrivateRoutes path='/video/details/:categoryId'>
          <VideoModulesDetails />
        </PrivateRoutes>
        <PrivateRoutes path='/videomodulesEditDetails'>
          <VideoModulesEditDetails />
        </PrivateRoutes>

        <PrivateRoutes path='/LegalDisclaimer'>
          <LegalDisclaimer />
        </PrivateRoutes>

        <PrivateRoutes path='/PrivacyPolicy'>
          <PrivacyPolicy />
        </PrivateRoutes>

        <PrivateRoutes path='/Sitemap'>
          <Sitemap />
        </PrivateRoutes>

        <PrivateRoutes path='/ChangePassword'>
          <ChangePassowrd />
        </PrivateRoutes>

        <PrivateRoutes path='/UserGroup'>
          <UserGroup />
        </PrivateRoutes>

        <PrivateRoutes path='/ManageCompany'>
          <ManageComapny />
        </PrivateRoutes>

        {/* <PrivateRoutes path='/event/:id'>
          <Event />
        </PrivateRoutes> */}

        <PublicRoutes path='/error'>
          <Error />
        </PublicRoutes>

        <PublicRoutes path='/RegisteredUser'>
          <RegisteredUser />
        </PublicRoutes>

        <PublicRoutes path='/NewUserRegister'>
          <NewUserRegister />
        </PublicRoutes>

        <PublicRoutes path='/middleware'>
          <Middleware />
        </PublicRoutes>

        <PublicRoutes path='/forgot'>
          <Forgot />
        </PublicRoutes>
        <PublicRoutes path='/forgotsuccess'>
          <ForgotSuccess />
        </PublicRoutes>
        <PublicRoutes path='/verifyotp'>
          <VerifyOtp />
        </PublicRoutes>
        <PublicRoutes path='/setpassword'>
          <SetPassword />
        </PublicRoutes>
        <PublicRoutes path='/setuserpassword'>
          <UserRegister />
        </PublicRoutes>
        <PublicRoutes path='/registersuccess'>
          <RegisterSuccess />
        </PublicRoutes>

        {/* <PublicRoutes path="/login1">
          <Login1 />          
        </PublicRoutes> */}

        <PublicRoutes path='/login'>
          <Login />
        </PublicRoutes>

        <PublicRoutes path='/'>
          <Redirect to='/home' />
        </PublicRoutes>
      </Switch>
    </>
  );
}

export default withRouter(Routes);
